import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const ATTENDANCE_REQUEST = 'FETCH_ATTENDANCE_REQUEST';
export const ATTENDANCE_FAILURE = 'FETCH_ATTENDANCE_FAILURE';
export const ATTENDANCE_SUCCESS = 'FETCH_ATTENDANCE_SUCCESS';

export const fetchAttendance = (competitionId) => {
    return function(dispatch) {
        dispatch({ type: ATTENDANCE_REQUEST, competitionId });
        return axios(apiRequestOptions(apiPath.ATTENDANCE.LIST, { competition: competitionId }))
            .then(transformHttpResponse)
            .then(response => dispatch({ type: ATTENDANCE_SUCCESS, data: response.data, competitionId }))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: ATTENDANCE_FAILURE, competitionId });
                dispatch(errorRequestHandler(error));
            });
    }
};
